import React, { useState, useEffect } from "react";
import axios from "axios";

interface Props {
  ndc: any;
}

const ItemImage: React.FC<Props> = ({ ndc }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Don't attempt to fetch if no NDC code is provided
    if (!ndc) {
      setLoading(false);
      return;
    }

    const formattedNdc = ndc.replace(/-/g, "");
    const imageUrlApi = `${process.env.REACT_APP_API_URL}/drug-images?ndc=${formattedNdc}`;

    setLoading(true);
    axios
      .get(imageUrlApi)
      .then((response) => {
        setImageUrl(response.data.imageUrl);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching drug image:", err);
        setLoading(false);
      });
  }, [ndc]); // Re-run effect when ndc changes

  if (!ndc) return null;
  if (loading) return <div></div>;
  if (!imageUrl) return <div></div>;

  return (
    <div style={{
        display: "flex",
        justifyContent: "start",
        alignItems: "start",
    }} >
      <img
        src={imageUrl}
        alt="Product"
        style={{
          width: "auto",
          height: "50px",
          maxHeight: "200px",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default ItemImage;
